































import { buySmsProduct } from '@/api/Sms/sms.api';
import { getProducts } from '@/api/Topup/topup.api';
import Autocomplete from '@/components/Autocomplete.vue';
import CreateDialog from '@/components/CreateDialog.vue';
import { Params, VueForm } from '@/utils/interfaces';
import { crudMixin } from '@/utils/mixins/crudMixin';
import { editMixin } from '@/utils/mixins/editMixin';
import { productsEnum } from '@/utils/productsCode.constant';
import mixins from 'vue-typed-mixins';
import { BuySmsProduct } from '@/utils/interfaces/sms.interface';
import { number } from '@/utils/validators';

export default mixins(crudMixin, editMixin).extend({
  components: { CreateDialog, Autocomplete },
  props: {},
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
        number: (v: string) =>
          number(v) || this.$t('validation.must-be-a-number'),
      },
      crud: {} as BuySmsProduct,
      defaultCrud: {
        destination_account: 'asededasd',
        product: productsEnum.SMS,
        amount: '',
        count: '',
      },
      getSmsProducts: (params?: Params) =>
        getProducts({ ...params, code: productsEnum.SMS }),
      loading: false,
    };
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm;
      if (!form.validate()) return;
      try {
        this.loading = true;
        const response = await buySmsProduct(this.crud);

        this.$emit('input', false);
        this.$emit('new-item', response.data);
      } finally {
        this.loading = false;
      }
    },
  },
});
